module.exports = __webpack_public_path__ + "static/media/Ladder-01-1.7aa9e521.jpg";